module.exports = __webpack_public_path__ + "static/images/gift-mod-t-bg.242f174.png";